export const replaceNonInteger = (value?: string): string =>
  value?.replace ? value.replace(/[^0-9]/g, '') : '';
